import React, { useRef } from 'react'
import { Imprimir, Voltar, BtnAcao } from './Acoes'
import ReactToPrint from 'react-to-print'
import { meses } from '../util/Utilitarios'
import { withRouter } from 'react-router-dom'
import '../assets/css/visualizacao.css'

const tipoGrupo = grupo => {
    const obj = {
        'tabela': <table className="table data-grid table-responsive-md table-visualizacao" >
            <thead>
                {grupo.thead}
            </thead>
            <tbody>
                {(grupo.tbody && grupo.tbody.length && grupo.tbody) || <tr><td className='div-center' colSpan={grupo.thead && grupo.thead.props.children.length}>Sem Registro</td></tr>}
            </tbody>
        </table>,
        default: () => grupo.colunas && grupo.colunas.map((coluna, index) => coluna &&
            <div key={index} className={coluna.tamanho + ' col-sm-12 mb-20'}>
                <span className="data-title">{coluna.titulo}</span>
                <span className="replace-empty">{coluna.descricao}</span>
            </div>
        )
    }

    return obj[grupo.tipoGrupo] || obj.default()
}

const VisualizacaoPadrao = props => {
    const reference = useRef();
    const btnPrint = useRef();
    const actualDate = new Date();
    const data = props.data

    return (
        <div className="card" ref={reference}>
            <ReactToPrint
                trigger={() => <button className={"hidden d-none"} ref={btnPrint} />}
                content={() => reference.current} pageStyle={`@page { size: ${props.orientacao || 'a4 auto'} }`} />
            {
                <div className="card-body">
                    <div className={'d-block-print'}>
                        <div className={'col-12 row mt-3'}>
                            <div className="col-8">
                                <h5>{data.titulo}</h5>
                                <h6>{actualDate.getDate().toString().padStart(2, '0') + ' de ' + (meses[actualDate.getMonth() + 1] || meses.default) + ' de ' + actualDate.getFullYear()}</h6>
                            </div>
                            <div className="col-4 text-right">
                                <img alt='logo' className="logo-menu" src={require('../assets/img/logo-coopanest.png')}></img>
                            </div>
                        </div>
                    </div>
                    <div className={'d-none-print colored'}>
                        <div className={'col-12 row mr-0 ml-0 mb-1 pr-0 pl-0'}>
                            <div className="col-12 row-space-between pr-0 pl-0">
                                <div>
                                    <BtnAcao icone="icon-Arrow-Left" texto="Voltar" action={() => props.history.goBack()} />
                                </div>
                                <div className="text-right">
                                    <Imprimir action={() => btnPrint.current.click()} />
                                </div>
                            </div>
                            <div className="col-12 titulo-visualizacao">
                                <h5>{data.titulo}</h5>
                                <h6>{actualDate.getDate().toString().padStart(2, '0') + ' de ' + (meses[actualDate.getMonth() + 1] || meses.default) + ' de ' + actualDate.getFullYear()}</h6>
                            </div>
                        </div>
                    </div>
                    {
                        data.grupos ? data.grupos.map((grupo, index) => grupo &&
                            <div className="dados-visualizacao" key={index}>
                                <div className="group-title">
                                    <h5>{grupo.titulo}</h5>
                                </div>
                                <div className="row">
                                    {tipoGrupo(grupo)}
                                </div>
                            </div>
                        ) : <div className="dados-visualizacao">
                            <div className="group-title">
                                <h5>Não há dados!</h5>
                            </div>
                        </div>
                    }
                    {
                        data.assinatura ?
                            <div className={'d-block-print'}>
                                <div className={'col-12 justify-content-center'}>
                                    <table className={'table-agrupamento mt-100 text-center'}>
                                        <tr className={''}>
                                            <td className='text-center'>
                                                <div >
                                                    <span >{'_______________________________________________________'}</span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className={''}>
                                            <td className='text-center'>
                                                <div style={{ display: 'flex' }}>
                                                    <span style={{ flex: 10 }}>{'Responsável'}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            : <></>
                    }
                </div>
            }
        </div>
    )
}

export default VisualizacaoPadrao